// src/AppWrapper.jsx
// Updated to use AWS Cognito instead of Auth0

import React from 'react';
import App from './App';
import { CognitoAuthProvider } from './aws-amplify-auth';

const AppWrapper = () => {
  return (
    <CognitoAuthProvider>
      <App />
    </CognitoAuthProvider>
  );
};

export default AppWrapper;
